<!-- 项目阶段 -->
<template>
  <div class="app-container">
    <el-card class="box-card">
      <!-- 搜索-->
      <dynamic-search :data="tableFilterList(tableHead)" @search="dataTableSearch">
        <template v-slot:next>
          <el-button icon="el-icon-plus" @click="add()">新增</el-button>
        </template>
      </dynamic-search>
      <drag-dialog
        append-to-body
        :show.sync="dialogVisible"
        title="项目阶段"
        :enableDrag="true"
        width="500px"
        @close="cancel"
      >
        <dynamic-form
          :formConfig="formConfig"
          labelWidth="110px"
          v-model="form"
          :look="openLook"
          @submit="submit"
          @cancelForm="cancel"
          :disabled="openLook"
          ref="pageForm"
        ></dynamic-form>
      </drag-dialog>
      <edit-data-table
        :head="tableHead"
        :data.sync="list"
        :total="total"
        :offset="offset"
        :page="page"
        :loading="loading"
        stripe
        @handlePageChange="dataTablePageChange"
        @handleSizeChange="dataTableSizeChange"
      >
        <template #toolbar="scope">
          <el-button type="text" size="mini" icon="el-icon-edit" @click="edit(scope.row)"></el-button>
          <el-popover :ref="scope.row.id" placement="top" width="180">
            <p>确定删除本条数据吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="$refs[scope.row.id].doClose()">取消</el-button>
              <el-button :loading="delLoading" type="primary" size="mini" @click="subDelete(scope.row.id)">确定</el-button>
            </div>
            <el-button type="text" size="mini" icon="el-icon-delete" slot="reference"></el-button>
          </el-popover>
        </template>
      </edit-data-table>
    </el-card>
  </div>
</template>

<script>
import "@/components/EditDataTable";
import DynamicSearch from "@/components/DynamicSearch";
import DataTableMixin from "@/mixins/DataTableMixin";
import DragDialog from "@/components/DragDialog";
import "@/components/dynamic-form";
import { addMilestoneNode, deleteMilestoneNode, editMilestoneNode } from "@/api/basic/milestoneNode";
export default {
  name: "MilestoneNode",
  directives: {},
  filters: {},
  mixins: [DataTableMixin],
  props: {},
  components: {
    DynamicSearch,
    DragDialog
  },
  created() {
    // 列表数据初始化
    this.$nextTick(() => {
      this.dataTableInit();
    });
  },
  data() {
    return {
      delLoading: false,
      openLook: false,
      form: {},
      dialogVisible: false,
      formConfig: {
        formItemList: [
          {
            type: "input",
            key: "code",
            label: "项目阶段代码",
            maxlength: "50",
            value: "",
            labelWidth: 120,
             rules: [
              {
                required: true,
                message: "项目阶段代码不能为空",
                trigger: "blur"
              },
              {
                pattern: "^[^\u4e00-\u9fa5]{0,}$",
                message: "项目阶段代码不能含有中文",
                trigger: "blur"
              },
            ]
          },
          {
            type: "input",
            key: "name",
            label: "项目阶段名称",
            value: "",
            maxlength: "100",
            labelWidth: 120,
            rules: [
              {
                required: true,
                message: "里程碑节点名称不能为空",
                trigger: "blur"
              }
            ]
          },
          {
            type: "textarea",
            key: "remark",
            maxlength: "200",
            label: "备注",
            value: "",
            placeholder: "请输入备注"
          }
        ]
      },
      tableHead: [
        {
          prop: "code",
          label: "项目阶段代码",
        },
        {
          prop: "name",
          label: "项目阶段名称",
          query: {
            type: "input"
          }
        },
        {
          prop: "remark",
          label: "备注",
        }
      ],
    };
  },
  computed: {},
  watch: {},
  methods: {
    editActiveEvent(row, column) {
      console.log(row, column);
    },
    dataTableBeforeInit() {
      this._url = `/bsMilestoneNode`;
      const params = {
        size: this.offset,
        page: this.page
      };
      this._params = Object.assign(params, this._query);
      return true;
    },
    // 打开新增
    add() {
      this.form = {};
      this.dialogVisible = true;
    },
    cancel() {
      this.dialogVisible = false;
    },
    // 删除
    subDelete(id) {
      this.delLoading = true;
      deleteMilestoneNode(id)
        .then(() => {
          this.delLoading = false;
          this.$refs[id].doClose();
          this.dleTableChangePage();
          this.dataTableInit();
          this.$notify({
            title: "删除成功",
            type: "success",
            duration: 2500
          });
        })
        .catch(() => {
          this.delLoading = false;
          this.$refs[id].doClose();
        });
    },
    submit() {
      if (this.form.id) {
        editMilestoneNode(this.form).then(res => {
          this.$notify({ title: "操作成功！", type: "success", duration: 2500 });
          this.dataTableInit();
          this.cancel();
        });
      } else {
        addMilestoneNode(this.form).then(res => {
           this.$notify({ title: "操作成功！", type: "success", duration: 2500 });
          this.dataTableInit();
          this.cancel();
        });
      }
    },
    // 打开修改
    edit(row) {
      this.form = row;
      this.dialogVisible = true;
    }
  }
};
</script>

<style scoped>
.el-form-item--small .el-form-item__label{
  width:160px !important;
}
</style>
